<template>
    <Card class="p-0 border-0">
        <CardContent class="relative p-0 rounded-lg overflow-hidden">
            <Image :desktop="product.feature_image" class="absolute opacity-25 w-[200%] h-[200%] object-cover" preset="thumbnail" />
            <Glass blur="lg" class="bg-white/10">
                <div class="flex flex-col justify-between w-full">
                    <div>
                        <NuxtLink :to="`/product/${product.slug}`" class="block aspect-square">
                            <Image class="w-full h-full" :desktop="product.feature_image" preset="thumbnail" />
                        </NuxtLink>
                        <Typography tag="h5" class="mt-4 px-2 text-center">
                            <NuxtLink :to="`/product/${product.slug}`">
                                <h2 class="font-bold text-vista-700 text-lg">{{ product.name }}</h2>
                            </NuxtLink>
                            <span class="text-muted text-xs"> {{ product.about }} </span>
                        </Typography>
                    </div>
                    <CardFooter class="flex justify-between mt-4 p-4">
                        <Button variant="soft" size="xs" class="group w-full cursor-pointer">
                            <NuxtLink :to="`/product/${product.slug}`">
                                <Icon name="majesticons:eye" class="size-4! text-accent/50 group-hover:text-accent-foreground" />
                                {{ $t("general.view") }}
                            </NuxtLink>
                        </Button>
                    </CardFooter>
                </div>
            </Glass>
        </CardContent>
    </Card>
</template>

<script lang="ts" setup>
import { Button } from "@/components/ui/button";
import { Glass } from "@/components/ui/glass";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import type { APIProduct } from "~~/shared/types/product";

interface Props {
    product: APIProduct;
}

defineProps<Props>();
</script>
